import React from 'react';
import { useController } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { CTextField } from '../StyledComponent';
import NumberTextField from '../NumberTextField';

function ControlledNumTextField({
    control, name, label, prefix = "", maxValue, minValue, allowNegative = false, InputProps = {},
    allowEmpty = false, onChange = () => { }, ...props
}) {
    const _defValue = props.defvalue ?? (allowEmpty ? "" : 0)
    const { field, formState: { errors } } = useController({ name, control, defaultValue: _defValue });
    const _onChange = (data, sourceInfo) => {
        if (sourceInfo.event === undefined) return
        field.onChange(data.floatValue ?? _defValue)
        onChange(sourceInfo.event)
    }

    return (
        <NumberTextField
            {...props}
            label={label}
            name={name}
            value={field.value}
            inputRef={field.ref}
            error={errors[name] !== undefined}
            helperText={errors[name]?.message ?? ""}
            prefix={prefix}
            thousandSeparator={props.thousandSeparator ?? true}
            decimalScale={props.decimalScale ?? 2}
            maxValue={maxValue}
            minValue={minValue}
            allowEmpty={allowEmpty}
            allowNegative={allowNegative}
            InputProps={InputProps}
            onChange={_onChange}
        />
    );
}

export default ControlledNumTextField;